/**
 * Table configuration constants
 */

export interface TableColumn {
  key: string;
  title: string;
  width: string;
}

export const TABLE_COLUMNS = {
  BANKS: [
    { key: 'logo_src', title: 'Логотип', width: '15%' },
    { key: 'name', title: 'Название', width: '50%' },
    { key: 'created_at', title: 'Дата добавления', width: '35%' },
  ] as const,

  WAREHOUSES: [
    { key: 'name', title: 'Название', width: '40%' },
    { key: 'address', title: 'Адрес', width: '40%' },
    { key: 'created_at', title: 'Дата создания', width: '20%' },
  ] as const,

  PRODUCT_CATEGORIES: [
    { key: 'name', title: 'Название', width: '70%' },
    { key: 'created_at', title: 'Дата создания', width: '30%' },
  ] as const,

  COUNTRIES: [
    { key: 'name', title: 'Название', width: '70%' },
    { key: 'created_at', title: 'Дата создания', width: '30%' },
  ] as const,

  GEKD_CODES: [
    { key: 'code', title: 'Код', width: '30%' },
    { key: 'name', title: 'Название', width: '50%' },
    { key: 'created_at', title: 'Дата создания', width: '20%' },
  ] as const,

  TNVED_CODES: [
    { key: 'code', title: 'Код', width: '30%' },
    { key: 'name', title: 'Название', width: '50%' },
    { key: 'created_at', title: 'Дата создания', width: '20%' },
  ] as const,

  UNITS: [
    { key: 'name', title: 'Название', width: '40%' },
    { key: 'short_name', title: 'Краткое название', width: '30%' },
    { key: 'created_at', title: 'Дата создания', width: '30%' },
  ] as const,

  BANK_ACCOUNTS: [
    { key: 'bank_name', title: 'Банк', width: '25%' },
    { key: 'name', title: 'Название счета', width: '25%' },
    { key: 'currency', title: 'Валюта', width: '15%' },
    { key: 'bank_account_number', title: 'Номер счета', width: '25%' },
    { key: 'created_at', title: 'Дата добавления', width: '10%' },
  ] as const,

  CONTRACTORS: [
    { key: 'name', title: 'Название', width: '40%' },
    { key: 'phone', title: 'Телефон', width: '25%' },
    { key: 'address', title: 'Адрес', width: '35%' },
  ] as const,

  CONTRACTS: [
    { key: 'contractor_name', title: 'Контрагент', width: '40%' },
    { key: 'sign_date', title: 'Дата подписания', width: '25%' },
    { key: 'amount', title: 'Сумма', width: '35%' },
  ] as const,

  PRODUCTS: [
    { key: 'code', title: 'Код', width: '15%' },
    { key: 'name', title: 'Название', width: '30%' },
    { key: 'category_name', title: 'Категория', width: '20%' },
    { key: 'count_display', title: 'Количество', width: '20%' },
    { key: 'warehouse_name', title: 'Склад', width: '15%' },
  ] as const,
} as const;

export const TABLE_CONFIG = {
  DEFAULT_PAGE_SIZE: 20,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
  EMPTY_MESSAGE: 'Нет данных для отображения',
} as const;
